import { render, staticRenderFns } from "./storeJoin.vue?vue&type=template&id=69adbaad&"
import script from "./storeJoin.vue?vue&type=script&lang=js&"
export * from "./storeJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports